import { Directive, inject, Injector } from '@angular/core';

@Directive({
  standalone: true,
  selector: 'ng-template[elementInjector]',
  exportAs: 'elementInjector',
})
export class ElementInjectorDirective {
  public readonly injector = inject(Injector);
}
